import { Learner } from "@hubcapp/types";
import { useQuery } from "@apollo/react-hooks";

import learnersForEvents from "../graph-ql/learnersForEvents.graphql";

const useQueryLearners = ({ instructorId }: { instructorId: string }) =>
  useQuery<{ instructor: { learners: Learner[] } }, { instructorId: string }>(
    learnersForEvents,
    {
      variables: { instructorId },
      fetchPolicy: "cache-first",
    },
  );
export default useQueryLearners;
